import React, { useEffect, useState } from "react";
import axiosInstance from "../../utils/axiosInstance";
import logo from "../../Assets/logo.jpg"; // ✅ your logo image
import "./UserOrderList.css";

const statusOptions = ["Pending", "Confirmed", "Shipped", "Delivered"];
const statusColors = {
  Pending: "#facc15",
  Confirmed: "#3b82f6",
  Shipped: "#f97316",
  Delivered: "#16a34a",
};

const UserOrderList = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedUserIds, setExpandedUserIds] = useState([]);

  useEffect(() => {
    fetchUsersOrders();
  }, []);

  const fetchUsersOrders = async () => {
    try {
      setLoading(true);
      const res = await axiosInstance.get("/users-orders");
      setUsers(res.data);
    } catch (err) {
      console.error("Error fetching users orders:", err);
    } finally {
      setLoading(false);
    }
  };

  const toggleUserExpand = (userId) => {
    setExpandedUserIds((prev) =>
      prev.includes(userId) ? prev.filter((id) => id !== userId) : [...prev, userId]
    );
  };

  const handleStatusChange = async (orderId, newStatus) => {
    try {
      await axiosInstance.patch(`/order/${orderId}/status`, { status: newStatus });
      setUsers((prevUsers) =>
        prevUsers.map((user) => ({
          ...user,
          orders: user.orders.map((order) =>
            order._id === orderId ? { ...order, status: newStatus } : order
          ),
        }))
      );
    } catch (err) {
      console.error("Failed to update order status:", err);
    }
  };

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <div className="admin-order-container">
      <h2>User Orders</h2>

      <table className="user-table">
        <thead>
          <tr>
            <th>User Name</th>
            <th>Email</th>
            <th>Mobile</th>
            <th>Total Orders</th>
            <th>Total Spent</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <React.Fragment key={user._id}>
              {/* ─────────────── User Row ─────────────── */}
              <tr className="user-row" onClick={() => toggleUserExpand(user._id)}>
                <td>{user.name}</td>
                <td>{user.email}</td>
                <td>{user.mobile}</td>
                <td>{user.totalOrders}</td>

                {/* 💰 Replace ₹ with logo */}
                <td>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <img
                      src={logo}
                      alt="currency"
                      style={{
                        width: "14px",
                        height: "14px",
                        borderRadius: "50%",
                        marginRight: "4px",
                        boxShadow: "0 1px 2px rgba(0, 0, 0, 0.25)",
                        objectFit: "cover",
                      }}
                    />
                    <span>{user.totalSpent}</span>
                  </div>
                </td>

                <td>
                  <button className="view-orders-btn">
                    {expandedUserIds.includes(user._id) ? "Hide Orders" : "View Orders"}
                  </button>
                </td>
              </tr>

              {/* ─────────────── Orders Row ─────────────── */}
              {expandedUserIds.includes(user._id) && (
                <tr className="order-details-row">
                  <td colSpan="6">
                    {user.orders.length === 0 ? (
                      <p>No orders</p>
                    ) : (
                      <table className="order-table">
                        <thead>
                          <tr>
                            <th>Order ID</th>
                            <th>Status</th>
                            <th>Total Amount</th>
                            <th>Created At</th>
                            <th>Items</th>
                          </tr>
                        </thead>
                        <tbody>
                          {user.orders.map((order) => (
  order ? ( // ✅ check order exists
    <tr key={order._id}>
      <td>{order._id}</td>
      <td>
        <select
          value={order.status || "Pending"} // fallback
          onChange={(e) => handleStatusChange(order._id, e.target.value)}
          style={{
            backgroundColor: statusColors[order.status] || "#facc15",
            color: "#fff",
            border: "none",
            padding: "4px 8px",
            borderRadius: "4px",
          }}
        >
          {statusOptions.map((status) => (
            <option key={status} value={status}>
              {status}
            </option>
          ))}
        </select>
      </td>
      <td>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <img
            src={logo}
            alt="currency"
            style={{ width: "14px", height: "14px", borderRadius: "50%", marginRight: "4px", boxShadow: "0 1px 2px rgba(0,0,0,0.25)", objectFit: "cover" }}
          />
          <span>{order.totalAmount || 0}</span>
        </div>
      </td>
      <td>{order.createdAt ? new Date(order.createdAt).toLocaleString() : "N/A"}</td>
      <td>
        <ul className="order-items">
          {order.items && order.items.length > 0 ? (
            order.items.map((item) =>
              item && item.item ? ( // ✅ check item exists
                <li key={item.item._id}>
                  {item.item.name} (Qty: {item.quantity},{" "}
                  <span style={{ display: "inline-flex", alignItems: "center" }}>
                    <img
                      src={logo}
                      alt="currency"
                      style={{ width: "12px", height: "12px", borderRadius: "50%", marginRight: "3px", boxShadow: "0 1px 2px rgba(0,0,0,0.25)", objectFit: "cover" }}
                    />
                    <span>{item.price || 0}</span>
                  </span>
                  )
                </li>
              ) : null
            )
          ) : (
            <li>No items</li>
          )}
        </ul>
      </td>
    </tr>
  ) : null
))}
                        </tbody>
                      </table>
                    )}
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UserOrderList;
